<template>

<div class="app-container">
    <el-tabs type="card" v-model="tabName" tab-position="top" >
        <!-- <el-tab-pane label="注塑工单" name="tab1" v-if="showTab1">
          <wj-glue></wj-glue>
        </el-tab-pane>
        <el-tab-pane label="特殊工艺工单" name="tab2" v-if="showTab2">
          <wj-special></wj-special>
        </el-tab-pane>
        <el-tab-pane label="配件工单" name="tab3" v-if="showTab3">
          <wj-fittings></wj-fittings >
        </el-tab-pane>
        <el-tab-pane label="装配工单" name="tab4" v-if="showTab4">
          <wj-assemble></wj-assemble>
        </el-tab-pane>
         <el-tab-pane label="组合工单" name="tab5" v-if="showTab5">
          <wj-combination></wj-combination>
        </el-tab-pane> -->
        <el-tab-pane
          v-for="(item, index) in machiningStageList"
          :key="index"
          :label="item.Name+'工单'"
          :name="item.Name"
        >
          <wj-currency :Stage="item.MachiningStageId" :StageName="item.Name"></wj-currency>
        </el-tab-pane>
      </el-tabs>
  </div>

</template>
<script>
import wjAssemble from "./assemble";
import wjCombination from "./combination";
import wjFittings from "./fittings";
import wjGlue from "./glue";
import wjSpecial from "./special";
import wjCurrency from "./currency";

export default {
  name: "workorder",
  components: {
    wjAssemble,wjCombination, wjFittings, wjGlue, wjSpecial, wjCurrency
    
  },
  data() {
    return {
      tabName: 'tab1',
      //加工类型
      machiningStageApi: require("@/api/ba/machiningStage").default,
      machiningStageList: [],
      showTab1: true,
      showTab2: true,
      showTab3: true,
      showTab4: true,
      showTab5: true
    };
  },
  created(){
    this.machiningStageApi.list({ Status: 1,Universal:true}).then((res) => {
      this.machiningStageList = res.Data;
      this.tabName = this.machiningStageList[0].Name
    });
    this.machiningStageApi.list({}).then(res => {
      if(res.Code === 0){
        res.Data.forEach(item => {
          if(item.Name === '注塑'){
            if(!item.Status){
              this.showTab1 = false
              this.showTab2 = false
            } 
          }
          if(item.Name === '配件'){
            if(!item.Status) this.showTab3 = false
          }
          if(item.Name === '装配'){
            if(!item.Status) this.showTab4 = false
          }
          if(item.Name === '组合'){
            if(!item.Status) this.showTab5 = false
          }
        })
      }
    })
  },
  activated(){
    if(this.$router.history.current.params){
      let docType = this.$router.history.current.params.DocType;
      if(docType === '注塑工单'){
        this.tabName = 'tab1';
      }else if(docType === '特殊工艺工单'){
        this.tabName = 'tab2';
      }else if(docType === '配件工单'){
        this.tabName = 'tab3';
      }else if(docType === '装配工单'){
        this.tabName = 'tab4';
      }else if(docType === '组装工单'){
        this.tabName = 'tab5';
      }

      console.log('this.tabName', this.tabName)

    }
  }
 
};
</script>
<style lang="scss" scoped>
.count {
  margin-right: 15px;
  font-size: 14px;
  color: red;
  display: inline-block;
}
</style>